export const KNOWLEDGE_BASE = {
  GOOGLE_AD_MANAGER_CONNECTION:
    'https://knowledge-base.yieldbird.com/yieldbird-platform/gam-api-connection#block-ee3416da97054c5596d2eb8b3d6a5fb0',
  PREBID_BIDDERS: 'https://knowledge-base.yieldbird.com/prebid-stack/demand-organization',
  URL_FILTERING: 'https://knowledge-base.yieldbird.com/prebid-stack/url-filtering',
  USER_MANAGEMENT: 'https://knowledge-base.yieldbird.com/yieldbird-platform/users-management',
} as const
